module.exports = __webpack_public_path__ + "img/6ae0bde089dcfc81b6f8dd01f46409fc.2db08493.png";